import Box from '@mui/material/Box'
import type { SurveyQuestion } from '../../../lib/survey-question.types'
import {
  surveyYesNoColumnSx,
  surveyYesNoOptionSelectedSx,
  surveyYesNoOptionSx,
  surveyYesNoRowSx,
} from '../../../styles/surveyExecutionStyles'
import { YesNoToggleControl } from './YesNoToggleControl'

interface YesNoQuestionProps {
  readonly question: SurveyQuestion
  readonly value: string | null
  readonly onChange: (value: 'yes' | 'no') => void
}

export function YesNoQuestion({ question, value, onChange }: YesNoQuestionProps) {
  if (question.yesNoToggleStyle) {
    return (
      <YesNoToggleControl
        yesLabel={question.yesLabel}
        noLabel={question.noLabel}
        value={value === 'yes' || value === 'no' ? value : null}
        onChange={onChange}
        questionId={question.id}
      />
    )
  }

  const rowSx = question.layoutHorizontal ? surveyYesNoRowSx : surveyYesNoColumnSx
  const options: Array<{ id: 'yes' | 'no'; label: string }> = [
    { id: 'yes', label: question.yesLabel },
    { id: 'no', label: question.noLabel },
  ]

  return (
    <Box sx={rowSx} role="radiogroup" aria-label={question.prompt}>
      {options.map((opt) => {
        const selected = value === opt.id
        return (
          <Box
            key={opt.id}
            component="button"
            type="button"
            role="radio"
            aria-checked={selected}
            data-testid={`survey-q-${question.id}-option-${opt.id}`}
            onClick={() => onChange(opt.id)}
            sx={{
              ...surveyYesNoOptionSx,
              ...(selected ? surveyYesNoOptionSelectedSx : {}),
            }}
          >
            {opt.label}
          </Box>
        )
      })}
    </Box>
  )
}
